<template>
  <b-card>
    <div class="flex justify-between">
      <h2 class="fsize24">Subscription Users</h2>
      <div class="flex">
        <base-button outline type="primary" class="flex px-3 py-1 mx-1">
          <download-excel
            class="mr-1 flex"
            default-value=""
            :fetch="fetchSelected"
            :fields="json_fields"
            worksheet="My Worksheet"
            name="SubscriptionUsers_Selected.xls"
          >
            <feather-icon icon="UploadIcon" class="mr-2 cust-HW"></feather-icon
            >Export Selected
          </download-excel>
        </base-button>
        <base-button outline type="primary" class="flex px-3 py-1 mx-1">
          <download-excel
            class="mr-1 flex"
            default-value=""
            :fetch="fetchData"
            :fields="json_fields"
            worksheet="My Worksheet"
            name="SubscriptionUsers_All.xls"
          >
            <feather-icon icon="UploadIcon" class="mr-2 cust-HW"></feather-icon
            >Export All
          </download-excel>
        </base-button>
      </div>
    </div>
    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
        v-model="search"
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <div class="pt-5">
      <el-table
        style="width: 100%"
        class="mt-4 rounded"
        header-row-class-name="thead-light table-th-color "
        :data="getAllPayments.result"
        @selection-change="selectedRow"
        border
      >
        <el-table-column type="selection" width="50px"> </el-table-column>

        <el-table-column prop="id" label="Order ID" min-width="150">
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.orderId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name" min-width="180">
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.fullname }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="Email" min-width="180">
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.userId.email }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="Mobile No." min-width="180">
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.userId.mobile }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="subtype"
          label="Subscription Type"
          min-width="180"
        >
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{
              row.userId.firstname
            }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="subplan"
          label="Subscription Plan"
          min-width="190"
        >
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.membershipName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="Status" min-width="180">
          <template v-slot="{ row }">
            <span class="text-black text-center font-medium">{{
              row.membershipStatus.toUpperCase()
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="validity" label="Purchased On" min-width="150">
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{
              new Date(row.createdAt).toLocaleDateString("en-Gb", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="validity" label="Validity" min-width="150">
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{
              new Date(row.userId.membershipValidity).toLocaleDateString(
                "en-Gb",
                {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                }
              )
            }}</span>
          </template>
        </el-table-column>
      </el-table>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          @change="handlePageChange"
          :per-page="perPage"
          :total="total_row"
        ></base-pagination>
      </b-card-footer>
    </div>
  </b-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      currentPage: 1,
      total_row: 1,
      perPage: 10,
      selectedData: [],
      search: "",
    };
  },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        this.getData();
      }, 500),
    },
  },
  computed: {
    ...mapState("payment", { getAllPayments: "getAllPayments" }),
    json_fields() {
      return {
        OrderId: "orderId",
        Name: "fullname",
        Email: "userId.email",
        Mobile: "userId.mobile",
        Subscription_Plane: "membershipName",
        Price: "price",
        Status: "membershipStatus",
        Purchased_on: {
          field: "createdAt",
          callback: (date) => {
            return new Date(date).toDateString();
          },
        },
        Validity: {
          field: "userId.membershipValidity",
          callback: (date) => {
            return new Date(date).toDateString();
          },
        },
      };
    },
  },
  methods: {
    selectedRow(val) {
      this.selectedData = val;
    },
    async fetchSelected() {
      if (this.selectedData.length === 0) {
        return this.$swal({
          title: "No Selection!",
          html: `<p class="text-center">Please select rows to be exported!</p>`,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
      }
      let loader = this.$loading();
      try {
        loader.close();
        this.$swal({
          html: `<p class="text-center">Data has been successfully exported!</p>`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
        return this.selectedData;
      } catch (error) {
        loader.close();
      }
    },
    async fetchData() {
      let payload = {
        limit: this.getAllPayments.totalCount,
      };

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch(
          "payment/getAllPayments",
          payload
        );
        // console.log(data, "///");
        if (data.code == 200) {
          loader.close();
          this.$swal({
            html: `<p class="text-center">Data has been successfully exported!</p>`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          this.getData();
          return data.data.result;
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async handlePageChange(value) {
      this.currentPage = value;
      try {
        this.getData();
      } catch (error) {}
    },
    async getData() {
      let payload = {
        search: this.search.trim(),
        limit: 10,
        offset: this.currentPage - 1,
      };
      try {
        await this.$store.dispatch("payment/getAllPayments", payload);
        this.total_row = this.getAllPayments.totalCount;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
